/*  ========================================================================
    # Components - Sections - Who Is Raiffeisen
    ========================================================================  */

// Dependencies
import React, { useRef } from 'react';
import Pill from '../components/Pill';
import Modal from '../components/Modal';

const WhoIsRaiffeisen = () => {
  const modalRef = useRef(null);

  return (
    <section id='who-is-raiffeisen' className='s-who-is-raiffeisen'>
      <div className='container'>
        <Pill
          alt='Wer ist die Deutsche Friedrich-Wilhelm-Raiffeisen-Gesellschaft e. V.?'
          text='Wer ist die Deutsche Friedrich-Wilhelm-Raiffeisen-Gesellschaft e. V.?'
          image='/wp-content/themes/raiffeisen-foerderpreis/dist/images/misc/raiffeisen-gesellschaft.jpg'
          onClick={() => modalRef.current?.open()}
          withGradient
        />
        <Modal ref={modalRef}>
          <Pill
            alt='Wer ist die Deutsche Friedrich-Wilhelm-Raiffeisen-Gesellschaft e. V.?'
            image='/wp-content/themes/raiffeisen-foerderpreis/dist/images/misc/raiffeisen-gesellschaft.jpg'
          />
          <div className='wysiwyg-block'>
            <h1 className='s-who-is-raiffeisen__modal-headline u-text-blue'>
              Wer ist die Deutsche Friedrich-Wilhelm-Raiffeisen-Gesellschaft e. V.?
            </h1>
            <p>
              In der Mitte des 19. Jahrhunderts herrschte eine Hungersnot im Westerwald. Wilhelm
              Friedrich Raiffeisen, damaliger Bürgermeister, fand eine Lösung. Er gründete einen
              Konsumverein, bei dem wohlhabendere Bürger ihre Ersparnisse einbrachten, damit
              Getreide für Menschen gekauft werden konnte, die es sich nicht leisten konnten. Zudem
              konnte mithilfe des Vereins ein gemeinschaftliches Backhaus bereitgestellt werden und
              bedürftigen Bauern ein Darlehen zum Kauf von Vieh gewährt werden. Damit leistete die
              Gemeinschaft Hilfe zur Selbsthilfe – ein Grundsatz der Genossenschaften.
            </p>
            <p>
              Die
              {' '}
              <a
                href='https://www.raiffeisen-gesellschaft.de'
                title='Raiffeisen-Gesellschaft'
                target='_blank'
                rel='noreferrer'
              >
                Raiffeisen-Gesellschaft
              </a>
              {' '}
              wurde 2012 gegründet und pflegt seitdem die genossenschaftlichen Ideen und Werte.
            </p>
            <p>
              Der Förderpreis der Deutschen Friedrich-Wilhelm-Raiffeisen-Gesellschaft e.V. wird mit
              Unterstützung der Stiftung des Förderkreises der Genossenschaftsmitglieder durchgeführt.
            </p>
          </div>
        </Modal>
      </div>
    </section>
  );
};

export default WhoIsRaiffeisen;
